export const generateHash = (obj) => {
  if (!obj) return "";
  try {
    const str = JSON.stringify(obj);
    return btoa(encodeURIComponent(str)).replace(/[^a-zA-Z0-9]/g, "");
  } catch {
    return "";
  }
};
